<rask-container-block>
  <ng-container header>Flytta avtal</ng-container>
  <div class="row">
    <div class="col-md-12" [formGroup]="form">
      <rask-search
        style="width: 200px"
        aid="inputAnvandareFrom"
        label="Från användare"
        bindLabel="namn"
        bindValue="id"
        typeToSearchText="Skriv namn.."
        loadingText="Laddar..."
        [selected]="form.value.fromUserSearch"
        formControlName="fromUserSearch"
        notFoundText="Ingen träff"
        [minTermLength]="3"
        [typeaheadFn]="searchAnvandareTypeahead">
      </rask-search>

      <rask-tree-selector
        class="col-2"
        label="Kontraktstatus"
        infoText="Sök fram avtal som har minst ett kontrakt med den eller de valda statusarna"
        [items]="kontraktstatusar"
        formControlName="kontraktstatus">
      </rask-tree-selector>

      <rask-tree-selector
        class="col-2"
        label="Affärsform"
        infoText="Sök fram avtal som har minst ett kontrakt med den eller de valda affärsformerna"
        [items]="affarsformer"
        [autoSort]="false"
        formControlName="affarsform">
      </rask-tree-selector>

      <rask-tree-selector
        class="col-2"
        label="Status i VACS"
        infoText="Sök fram avtal som har minst ett kontrakt med den elle de valda statusarna"
        [items]="vacsKontraktstatusar"
        formControlName="vacsStatus">
      </rask-tree-selector>

      <rask-button color="secondary" (click)="searchAvtal()" class="button-no-header"
      [disabled]="!hasSearchData()">Sök</rask-button>
      <rask-button color="secondary" (click)="clearAll()" class="button-no-header">Rensa</rask-button>

    </div>
  </div>
</rask-container-block>

@if (avtalList?.length > 0) {
  <rask-container-block>
    <ng-container header>Sökresultat</ng-container>
    <div class="move-table-wrapper">
      <table class="svea-table moveTable ms-2">
        <thead>
          <tr class="rask-header-row rask-row">
            <th class="name-column-header">Namn</th>
            <th class="active-column-header">
              <rask-checkbox (change)="checkAll($event)" [(ngModel)]="isAllChecked"></rask-checkbox>
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            @for (model of avtalList; track model) {
              <tr>
                <ng-container>
                  <td>
                    <div>
                      <a [routerLink]="['/virkeskop/avtal', model.avtal.id]" target="_blank">
                        {{model.avtal.benamning}} {{model.avtal.avtalsnummer}} (ny flik)
                        <i class="fa-regular fa-up-right-from-square"></i>
                      </a>
                      <div>
                        @for (k of model.avtal.kontrakt; track k) {
                          <span class="sublabel">
                            {{ k.benamning }}, {{ k.kontraktnummer }}, {{ k.affarsform }}, {{ k.status }}, {{ getVacsStatusText(k.vacsStatusCode) }} |
                          </span>
                        }
                      </div>
                    </div>
                  </td>
                  <td class="svea-input fkm-input-col">
                    <rask-checkbox (change)="selectedChanged($event)" [(ngModel)]="model.selected">
                    </rask-checkbox>
                  </td>
                </ng-container>
              </tr>
            }
          </ng-container>
        </tbody>
      </table>
    </div>
    <div [formGroup]="form" class="mb-5">
      <rask-search
        style="width: 300px"
        aid="inputAnvandareTo"
        label="Flytta markerade avtal till användare"
        bindLabel="namn"
        bindValue="id"
        typeToSearchText="Skriv namn.."
        loadingText="Laddar..."
        [selected]="form.value.toUserSearch"
        formControlName="toUserSearch"
        notFoundText="Ingen träff"
        [minTermLength]="3"
        [typeaheadFn]="searchAnvandareTypeahead">
      </rask-search>
      <rask-button color="primary"
        (click)="moveSelectedContracts()"
      [disabled]="!hasMoveData()">Flytta {{ getSelectedCount() }} avtal</rask-button>
    </div>
  </rask-container-block>
}